<template>
  <div>
    <Div v-if="data['iframe']">
      <iframe
        ref="iframe"
        allow="camera; microphone"
        :src="data['iframe']"
        frameBorder="0"
        class="iframe"
      />
    </Div>

    <div class="install-control">
      <button @click="back" class="btn btn-danger">
        {{ "back_step" | setText("Назад") }}
      </button>
      <button @click="send" class="btn btn-success">
        {{ "next_step" | setText("Далее") }}
      </button>
    </div>
    
  </div>
</template>
<script>
import { logger, errorNotify } from "../../../plugins/functions";

export default {
  watch: {},
  components: {},
  props: {
    order: {
      default: function () {
        return {};
      },
    },
    transaction: {
      default: function () {
        return null;
      },
    },
    partner: {
      default: function () {
        return {};
      },
    },
    updateOrder: {
      default: function () {},
    },
    value: {
      default: function () {},
    },
    createTransaction: {
      default: function () {},
    },
  },
  name: "filter",
  async created() {},
  methods: {
    back() {
      this.$emit("setStep", "tbc-accept");
    },
    async send() {
      let data = {
        loan_id: this.transaction["exchange_id"],
      };

      this.$loading(true);
      this.$http({
        url: `${this.partner["endpoint_url"]}tbc-add-card `,
        method: "POST",
        headers: {
          Authorization: `${
            this.partner["type_auth"] ? this.partner["type_auth"] + " " : ""
          }${this.partner["api_secret_key"]}`,
          "Content-Type": "application/json",
          Accept: "application/json",
          "agent-id": this.partner["api_public_key"],
        },
        data: data,
      })
        .then((response) => {
          this.data = response.data;
        })
        .catch((error) => {
          errorNotify(error, this.$notify);
        })
        .finally(() => {
          this.$loading(false);
        });
    },
  },
  data() {
    return {
      data: {},
    };
  },
};
</script>

